$(document).ready(function(){ 

    // Applica solo su mobile
    if (window.innerWidth <= 767) {
      console.log('fabio 3');
      const sections = document.querySelectorAll(".flex-heightfull .col-xs-12");

      sections.forEach(section => {
        const title = section.querySelector("p.lead");
        const list = section.querySelector("ul");

        if (title && list) {
          // Aggiungi freccia e classi
          title.classList.add("accordion-title");
          list.classList.add("accordion-content");

          // Inizialmente chiuso
          list.style.maxHeight = "0px";
          list.style.overflow = "hidden";
          list.style.transition = "max-height 0.3s ease";

          // Toggle al click
          title.addEventListener("click", () => {
            title.classList.toggle("open");
            if (list.style.maxHeight === "0px") {
              list.style.maxHeight = list.scrollHeight + "px";
            } else {
              list.style.maxHeight = "0px";
            }
          });
        }
      });
    }
  
});

